import React from "react";
import { useSessionContext } from '@contexts';
import PropTypes from 'prop-types';

const GuarantorOption = ({ children }) => {

    const { session } = useSessionContext();

    return (
        <>
            {
                session.isGuarantor &&
                children
            }
        </>
    );
};

GuarantorOption.propTypes = {
    children: PropTypes.element.isRequired
};

export default GuarantorOption;